export default __webpack_public_path__ + "static/media/dark-logo.95c231f5.svg";